/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationApplicationByContext {
    getFixupPrototypeFunction() { return GovernanceConfigurationApplicationByContext.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationApplicationByContext>): GovernanceConfigurationApplicationByContext {
        let obj = Object.assign(new GovernanceConfigurationApplicationByContext(), model);
        GovernanceConfigurationApplicationByContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationApplicationByContext>): GovernanceConfigurationApplicationByContext {
        if (!model) return null;
        return GovernanceConfigurationApplicationByContext.newInstance(<GovernanceConfigurationApplicationByContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationApplicationByContext) {
        if (!obj) return;

        models.GovernanceConfigurationApplicationByContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationApplicationByContext): boolean {
        Object.setPrototypeOf(obj, GovernanceConfigurationApplicationByContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.context) {
            models.GovernanceConfigurationBase.fixupPrototype(this.context);
        }
        if (this.steps) {
            for (let val of this.steps) {
                models.GovernanceConfigurationApplicationStep.fixupPrototype(val);
            }
        }
    }

    /**
     * Governance Configuration settings to apply
     */
    context: models.GovernanceConfigurationBase;

    /**
     * Steps to apply configuration
     */
    steps: Array<models.GovernanceConfigurationApplicationStep>;

}
